<template>
  <div>
    <div class="spinner-cover" v-if="isLoading">
      <div class="spinner"></div>
    </div>
    <TopBar class="bg-white" :range="range"/>
    <vue-confirm-dialog persistent/>

    <div id="main" class="skybackground pt-0 pb-0">
      <!--   Modal for select is document type is special report or daily report-->
      <document-type-modal/>

      <side-nav :searchString="searchstring"/>

      <a id='dwnldLnk' download='photoReport Project Docu.pdf' style="display:none;"/>

      <div class="row justify-content-center">
        <div class="col-md-6 pr-0 pl-1" id="doctable">
          <div class="doctable">
            <div class="tableFixHead cscroll" :class="{selectionactive : selectedRecords.length}">
              <div class="search-bar pt-2 pb-1 col-md-12">
                <div class="row">
                  <div class="col-6  pr-lg-1 pr-xl-2">
                    <div class="mt-1">
                      <button title="Fotodokumentation erstellen" type="button" @click="$store.commit('setTempPhotos',[])" class="border-0" data-toggle="modal" data-target="#fdemodal" :disabled="!usercan('editor')">
                        <img class="plus-img" src="@/assets/images/plus.png" alt="image">
                      </button>
                     <span class="icons-text-top-bar">Fotodokumentation erstellen</span>
                    </div>
                  </div>
                  <div class="col-6 pl-1">
                      <div class="form-group text-right doc-search mb-2 pb-1 position-relative w-100">
                        <input type="text" v-model="searchstring" class="form-control border float-right" placeholder="Suche" style="max-width: 100%">
                        <img class="form-control-feedback search-img" src="@/assets/images/search.png" alt="img" style="top: 0; right: 4px">
                        <div class="clearfix"></div>
                      </div>
                  </div>
                </div>
              </div>
              <table class="table table-hover table-fixed position-relative">
                <thead>
                <tr>
                  <th class="text-center" style="width:30px;">
                    <input type="checkbox" class="master-checkbox" v-model="masterCheckbox">
                  </th>
                  <th class="pl-1"  style="width:50px;">PDF</th>
                  <th>
                    {{ $t('reports') }}
                  </th>
                  <th  style="width:180px;">
                    Berichtersteller
                  </th>
                  <th  style="width:120px;">
                    {{ $t('date') }}
                  </th>
                  <th  style="width:120px;">
                    Aktualisiert
                  </th>

                  <th style="width:35px;">Rev.</th>
                  <th style="width:55px;"></th>
                </tr>
                </thead>
                <tbody>
                  <tr v-for="doc in photoDocuments" :key="doc.pdreportid" @click="selectDocument(doc,$event)" class="table-row" :class="{active_tr : doc.pdreportid === selectedDocument.pdreportid}">
                  <td class="text-center" data-value="btn">
                    <input type="checkbox" aria-label="Checkbox for following text input" :value="doc.pdreportid" v-model="selectedRecords" data-value="btn">
                  </td>
                  <td class="pl-1">
<!--                    <i class="fa fa-circle" v-if="!doc.generated">LOAD</i>-->
                    <img src="@/assets/images/pdf-icon.png" @click="downloadOrPreviewDocumentPdf(doc,false)" alt="icon" class="icon pr-2" data-value="btn" title="Öffnen im Browser">
                    <img src="@/assets/images/download-icon.png" @click="downloadOrPreviewDocumentPdf(doc,true)" alt="icon" class="icon" data-value="btn" title="PDF herunderladen">
                  </td>
                  <td style="word-wrap: normal; white-space: normal;">
                    <div style="width:100%; text-overflow: ellipsis; overflow: hidden;">
                      {{ doc.reportname }}
                    </div>
                  </td>
                  <td>
                    {{ doc.creator }}
                  </td>
                  <td>{{ doc.reportdate | setDateFormat }}</td>
                  <td>{{ doc.created | setDateFormat }}</td>
                  <td>
                    {{doc.revision }}
<!--                    <template v-if="usercan('editor')">-->
<!--                      <img src="@/assets/images/delete_icon.png" data-value="btn" alt="remove" class="delete-icon float-right" width="21" @click="deleteDocument(doc.pdreportid)" title="Löschen">-->
<!--                    </template>-->
                  </td>
                  <td>
                    <template v-if="doc.locked">
                      <i class="fa fa-lock float-right mr-2" style="margin-left: 5px;height: 14px; vertical-align: middle;" title="PDF freigegeben"></i>
                    </template>
                    <template v-if="candeleteReport(doc)">
                      <img src="@/assets/images/delete_icon.png" data-value="btn" alt="remove" class="delete-icon position-absolute" width="21" @click="deleteDocument(doc.pdreportid)" title="Löschen">
                    </template>
                  </td>
                </tr>
                </tbody>
                <tbody v-if="meta.maxcount === 0">
                  <tr>
                    <td colspan="7" class="text-center">
                      <h4 class="mt-4">Keine Fotodokumentation vorhanden</h4>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div v-if="selectedRecords.length" class="shadow btns-bar border-top border-dark docs-pagination col-md-12 bg-white text-center position-absolute">
            <div class="pt-1 p1-0">
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-4 text-left pl-0 pr-1">
                    Ausgewählte Fotodokumentationen : <strong> {{selectedRecords.length}} </strong>
                  </div>
                  <div class="col-md-8 text-right">
                    <button class="btn btn-light shadow-lg font1rem mb-1" @click="masterCheckbox = true">
                      Alle auswählen
                    </button>
                    <button class="btn btn-light font1rem shadow-lg mb-1" @click="masterCheckbox = false">
                      Auswahl aufheben
                    </button>
                    <button class="btn btn-light font1rem shadow-lg mb-1" @click="makeTicket">
                      Ticket erstellen
                    </button>
                    <button class="btn btn-light font1rem shadow-lg mb-1 ml-2" type="button" @click="startdownload()">
                      Als ZIP Archiv speichern
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <div class="border-top border-dark  docs-pagination col-md-12 bg-white text-center" >
            <div class="pt-1 pb-0" v-if="meta.maxcount > 20">
              <div class="position-absolute items-count-bar">
                <span class="font-weight-normal" v-if="meta.maxcount > 20"> {{currentPage === 1 ? '1' : ((currentPage - 1) * 20)}} bis {{currentPage * 20}} von  {{meta.maxcount}} Fotodokumentationen</span>
                <span class="font-weight-normal" v-else> 1 bis {{ meta.maxcount }} von  {{meta.maxcount}} Fotodokumentationen</span>
              </div>
              <sliding-pagination
                :current="currentPage"
                :total="Math.ceil(meta.maxcount / 20)"
                @page-change="pageChangeHandler"/>
            </div>
          </div>
        </div>

        <preview v-if="photoDocuments.length > 0"/>
      </div>
    </div>
  </div>
</template>
<script>

import SideNav from './SideNav'
import Preview from './Preview/Preview'
import { mapState } from 'vuex'
import SlidingPagination from 'vue-sliding-pagination'
import DocumentTypeModal from './DocumentTypeModal'
import { formatDate , todayDate } from '../../common'
import TopBar from './TopBar'
import axios from 'axios'
import moment from 'moment'

export default {
  components: {
    TopBar,
    SideNav,
    SlidingPagination,
    Preview,
    DocumentTypeModal
  },
  data () {
    return {
      selectedRecords: [],
      markallitems: '',
      searchstring: '',
      currentPage: 1,
      masterCheckbox: false,
      index: 0,
      range: [0,500],
      orderQry: [
        {
          "_explicitType":"com\\projectdocu\\OrderSettingVO",
          "fieldname":"created",
          "order":"DESC"
        }
      ]
    }
  },
  created () {
    console.log('CREATED PHOTODOCUMENTS')
    this.getDocs();
  },
  filters: {
    setDateFormat (date) {
     return  formatDate(date)
    },
  },
  methods: {

    makeTicket() {
      this.$store.state.tickets.selectedRecords = this.selectedRecords
      this.$store.state.tickets.createmode = true
      this.$router.push({name: 'Tickets', params: {id: this.$route.params.id}})
    },

    startdownload() {
      let projectId = this.$route.params.id
      console.log('Download starten', this.selectedRecords)


      var params = {
        "serviceName": "ProjectdocuService",
        "methodName": "getReportsAsZIP",
        "parameters": [
          this.selectedRecords
        ]
      }

      // this.$route.params.id,


      // await axios.post(this.getImagesUrl, paramsOld, {
      axios.post(process.env.VUE_APP_BASE_AMF_URL + `getReportsAsZIP&type=s&token=` + localStorage.sessiontoken, params, {
        headers: {
          apitoken: localStorage.apikey,
          deviceid: localStorage.deviceid,
          accept: 'application/json',
        },
        responseType: 'blob' // Need to serv correct file
      })
      .then(response => {
        console.log('Response', response)

        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement('a');

        fileLink.href = fileURL;
        fileLink.setAttribute('download', 'Dokumentation Sammlung.zip');
        document.body.appendChild(fileLink);

        fileLink.click();
      })
      .catch(error => console.log(error))
      .finally(() => {
        $('.spinner-cover').hide()
      })



    },

    candeleteReport(doc) {
      if(doc.locked) return false

      if(parseInt(doc.pduserid) == parseInt(this.currentuser.pduserid)) return true

      return parseInt(this.currentuser.rights) == 1;
    },

    async getDocs(){
      this.$store.commit('toggleLoading', true)
      await this.getPhotosDocsList();
      const dif_from = moment(this.meta.minimumDate , 'DD.MM.YYYY');
      const dif_to = moment(this.meta.maximumDate , 'DD.MM.YYYY');
      await this.$store.commit('setPhotoDocsMetaDateFrom',this.meta.minimumDate)
      await this.$store.commit('setPhotoDocsMetaDateTo',this.meta.maximumDate)
      const dif = moment.duration(dif_to.diff(dif_from)).asDays();
      this.range = [0 , dif];
      let my_range = $("#rangeSliderInPhotoDocs").data("ionRangeSlider");
      setTimeout(function (){
        my_range.update({min: 0, max: dif, to: dif, from: 0});
        //refresh datepicker after set the values
        const{ 0: from,1: to } = [$("#datepicker_from"),$("#datepicker_to")]
        to.datepicker("setDate", to.val());
        from.datepicker("setDate", from.val());
        to.datepicker('refresh');
        from.datepicker('refresh');
        my_range.reset();
      });
      const id = this.$route.params.docId
      const doc = this.photoDocuments.find(item => item.pdreportid == id) || this.photoDocuments[0]
      if (doc){
        await this.selectDocument(doc,"created")
      }else {
        await  this.$router.push( { name: 'photoDocumentation', params: { id: this.$route.params.id } })
      }
    },

    //get Documents list and maintain the selected document on created
     async getPhotosDocsList () {
      const payload = [this.$route.params.id, 20, 0, null, this.orderQry]
      //get all documents without any filter
      await this.$store.dispatch('getPhotoDocsList', payload)
      this.$store.commit('toggleLoading', false)
    },

     //when user select document
     async selectDocument (doc, event) {
      let _this = this
       if (event === 'created' || event.target.getAttribute('data-value') !== 'btn') {
         this.$store.commit('toggleLoading', true)
         const projectId = this.$route.params.id
         await this.$store.commit('setSelectedDocument', doc)


         this.selectedDocument.prevLockState = doc.locked

         if (doc.reporttype == '0') {
           await this.getPhotosOfDailyReport(doc.reportdate)
         } else {
           // Fetch
           const fetchparams = { ids: this.photoParams(), items: this.selectedDocument.pdreportitems }
           fetchparams.ids[1] = (this.selectedDocument.pdreportitems.length)
           await this.$store.dispatch('getImagesByIdsDocsModule', fetchparams)
         }
         if (this.$route.name !== 'photoDocumentationPreview'){
           await this.$router.push({
             name: 'photoDocumentationPreview',
             params: {id: projectId.toString(), docId: doc.pdreportid || 0}
           })
         }
       }
       this.$store.commit('toggleLoading', false)

       console.log('CurrentDoc', doc)
       console.log('CurrentLockState', this.selectedDocument)
     },

     pageChangeHandler (activePage) {
      this.currentPage = activePage
      this.getDocsByDate(true);
    },

     dailyProjectPhotosParams (report_date) {
      let id = this.$route.params.id
      return [id, null, 0,
        {'_explicitType': 'com\\projectdocu\\PredicateOperatorAndVO',
          'operands': [{
            _explicitType: 'com\\projectdocu\\PredicateOperandEQVO',
            fieldvalue: 1,
            fieldname: 'dailydocu'
          },{
            _explicitType: 'com\\projectdocu\\PredicateOperandEQVO',
            fieldname: 'photodate-day',
            fieldvalue: report_date.substr(0,10),
          }],
        },
        [{
          _explicitType: 'com\\projectdocu\\OrderSettingVO',
          fieldname: 'photodate',
          order: 'DESC'
        }]
      ]
    },

     //Get Images By Report Date If Report type is daily report / '0'
     async getPhotosOfDailyReport (report_date) {
      this.$store.commit('toggleLoading', true)
      let _this = this
      await axios.post(`${process.env.VUE_APP_BASE_AMF_URL}&token=${localStorage.sessiontoken}`,
        {
          'methodName': 'getPhotosOfProject',
          'serviceName': 'ProjectdocuService',
          'parameters': _this.dailyProjectPhotosParams(report_date)
        },
        {
          headers: {
            apitoken: localStorage.apikey,
            deviceid: localStorage.deviceid,
            accept: 'application/json'
          }
        }).then(res => {
          if (res.data.photos){
            res.data.photos.sort((a, b) => new Date(a.photodate.replaceAll('-', '/')) - new Date(b.photodate.replaceAll('-', '/')));
          }
        _this.getFilesDocsModule(res.data.photos)
        _this.$store.commit('toggleLoading', false)
      }).catch(error => {
        _this.$store.commit('toggleLoading', false)
      })
    },

    /**Get Photo Files for new daily report
     *
     * @param photos
     * @returns {Promise<void>}
     */
    async getFilesDocsModule (photos) {
      let _this = this
      _this.$store.commit('setDailyReportPhotos', [])
      _this.$store.commit('setPhotoContentImages', [])
      _this.$store.commit("setTempPhotos" ,[]);
      _this.$store.commit('toggleLoading', true)
      for (let i = 0; i < photos.length; i++){
        const photo = photos[i]
        const image = {
          pdphotoid: photo.pdphotoid,
          pdphototext: photo.description,
          description: photo.description,
          pduserid: photo.pduserid,
          runid: photo.runid,
          projectid: photo.projectid,
          photodate: photo.photodate,
          params: photo.params,
          origname: photo.origname
        }
        const imageCopy = {...image}
        imageCopy.pdphototext = image ? image.pdphototext : '';
        _this.$store.commit("pushInTempPhotos" ,image);
        _this.$store.commit("setPhotoContentImages" ,imageCopy);
        _this.$store.commit("pushInSelectedImages" ,imageCopy);

      }
      _this.$store.commit('toggleLoading', false)
    },

    formatDate: (val) => formatDate(val),


    //paras for get photos of selected document
    photoParams () {
      let photo_ids = []
      if (this.selectedDocument.pdreportitems.length) {
        photo_ids = this.selectedDocument.pdreportitems.map(item => {
          return {
            'fieldname': 'pdphotoid',
            'fieldvalue': `${item.pdphotoid}`,
            '_explicitType': 'com\\projectdocu\\PredicateOperandEQVO'
          }
        })
      }
      return [this.$route.params.id, null, 0,
        {
          'operands': photo_ids,
          '_explicitType': 'com\\projectdocu\\PredicateOperatorOrVO'
        },
        [{
          _explicitType: 'com\\projectdocu\\OrderSettingVO',
          fieldname: 'photo.pdphotoid',
          order: 'DESC'
        }]
      ]
    },

    //filter docs list by date
    async getDocsByDate (pagination = false) {
      // console.log('RELOAD DOCS!!!')
      let dateFrom = moment(this.dateRangeFrom , 'DD.MM.YYYY').format('YYYY-MM-DD');
      let dateTo = moment(this.dateRangeTo, 'DD.MM.YYYY').format('YYYY-MM-DD');
      let filters = { _explicitType: 'com\\projectdocu\\PredicateOperatorAndVO', operands: []}
      if (this.dateRangeFrom && dateFrom != 'Invalid Date'){
        const date_filter = {
          fieldname: 'reportdate',
          fieldvalueFrom: dateFrom +' 00:00:00',
          fieldvalueTo: dateTo +' 23:59:59',
          _explicitType: 'com\\projectdocu\\PredicateOperandBetweenVO',
        }
        filters.operands.push(date_filter)
      }
      if (!pagination) {
        this.currentPage = 1
        // console.log('photodocuments - getDocsByDate 1')
        await this.$store.dispatch('getPhotoDocsList', [this.$route.params.id, 20, 0, filters, this.orderQry])
      }else {
        // console.log('photodocuments - getDocsByDate 2')
        await this.$store.dispatch('getPhotoDocsList', [this.$route.params.id, 20, this.currentPage - 1, filters, this.orderQry])
      }
    },

    //method for download view pdf of document
    async downloadOrPreviewDocumentPdf (doc, isDownload) {
      let id = doc.pdreportid;
      this.$store.commit('loading', true)
      let _this = this
      const url = `${process.env.VUE_APP_GET_METHOD_URL}report&rid=${id}&token=${localStorage.sessiontoken}`
      await fetch(url, {
        headers: {
          apitoken: localStorage.apikey,
          deviceid: localStorage.deviceid,
        }
      }).then(response => response.blob())
        .then(response => {
          let reader = new FileReader()
          reader.readAsDataURL(response)
          reader.onload = function () {
            if (isDownload) {
              const dlnk = document.getElementById('dwnldLnk')
              dlnk.download =  doc.reporttype == '1' ?  `${todayDate()}_${doc.reportname}.pdf` : `${todayDate()}_Tagesreport vom ${moment(doc.reportdate).format('DD-MM-YYYY')}.pdf`
              dlnk.href = reader.result
              dlnk.click()
            } else {
              // Use as BLOB
              const data = window.URL.createObjectURL(response)
              var link = document.createElement('a')
              link.href = data
              link.target = '_blank'
              // link.download =  doc.reporttype == '1' ?  `${todayDate()}_${doc.reportname}.pdf` : `${todayDate()}_Tagesreport vom ${moment(doc.reportdate).format('DD-MM-YYYY')}.pdf`
              link.click()
              setTimeout(function() {
                window.URL.revokeObjectURL(data);
              }, 100)




              // const newTab = window.open('Construction-Report-PDF?printerFriendly=true', '_blank')
              // newTab.document.write(`<iframe width='100%' height='100%' src='${reader.result}'></iframe>`)
            }
            _this.$store.commit('loading', false)
          }
        }).catch(e => {
          _this.$store.commit('loading', false)
        })
    },

    //Method foe delete document
    async deleteDocument(id){
      this.$confirm({
        message: "Fotodokumentation löschen?",
        button: {
          no: 'Abbrechen',
          yes: 'Ja'
        }, callback: confirm => {
          if (confirm) {
            this.deleteDoc(id);
          }
        }
      });
    },

    async deleteDoc(id){
      await this.$store.dispatch('deletePhotoDocument',id);
      if (this.$route.name === 'photoDocumentationPreview'){
        await this.$router.push( { name: 'photoDocumentation', params: {id: this.$route.params.id } } );
      }
      await this.getPhotosDocsList()
      this.currentPage = 1
    },


    markAllItems() {
      let _this = this

      if(_this.selectedRecords.length) {
        _this.selectedRecords = [];
        $('.markAllItemsCheckbox').prop('checked', false);
      } else {
        _this.markallitems = true
        this.photoDocuments.forEach(function (value, i) {
          _this.selectedRecords.push(value.pdreportid);
        })
        $('.markAllItemsCheckbox').prop('checked', true);

      }
    }
  },
  computed: {
    ...mapState({
      photoDocuments: state => state.photoDocumentation.photoDocuments,
      dateRangeFrom: state => state.photoDocumentation.dateRangeFrom,
      dateRangeTo: state => state.photoDocumentation.dateRangeTo,
      selectedDocument: state => state.photoDocumentation.selectedDocument,
      meta: state => state.photoDocumentation.photoDocsMeta,
      isLoading: state => state.constructionDiary.is_loading
    }),
    checkedPhotos : {
      get(){
        return this.$store.state.photoDocumentation.selectedImages
      },
      set(val){
        this.$store.commit('setSelectedImages', val)
      }
    }
  },
  watch: {
    'dateRangeFrom': function () {
      this.getDocsByDate()
    },
    'dateRangeTo': function () {
      this.getDocsByDate()
    },
    $route: async function (){
      let id = this.$route.params.docId
      if (this.$route.name === 'photoDocumentationPreview' && id == 0){
        let doc = this.photoDocuments[0]
        if (doc){
          await this.selectDocument(doc,"created")
        }
      }
    },
    masterCheckbox: function (val){
      if (val){
        this.photoDocuments.forEach(item => {
          if (!this.selectedRecords.includes(item.pdreportid)){
            this.selectedRecords.push(item.pdreportid)
          }
        })
      }else if (val === false){
        this.selectedRecords = []
      }
    }
  }
}
</script>
<style scoped>
.active_tr {
  background: lightgray;
}
tr.table-row:hover {
  background: lightgray !important;
  cursor: pointer;
}

td .icon:hover {
  cursor: pointer;
}
.position-absolute.delete-icon{
  right: 10px;
  display: none;
  visibility: inherit;
}
table tr:hover td .position-absolute.delete-icon{
  display: block;
}

.btns-bar.position-absolute{
  bottom: 40px;
}
#doctable {
  overflow: hidden;
}
.selectionactive {
  padding-bottom: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/photoDocumentation/components/PhotoDocumentsList.vue